import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {ApiSportsEndPointResponse} from "./types";
import {AuthUser, User, UserFormData} from "../../types/user";
import {storedReferralCode} from "../referral";

export const currentUser = async (client: AxiosInstance) =>
    responseHandler<ApiSportsEndPointResponse<User>>(client.get('/auth/currentUser'))

/** The referral code defaults to the one captured from a share link when the caller omits it */
export const register = async (client: AxiosInstance, userFormData: UserFormData) =>
    responseHandler<ApiSportsEndPointResponse<AuthUser>>(client.post('/auth/register', {
        ...userFormData,
        referralCode: userFormData.referralCode || storedReferralCode()
    }))

/**
 * Exchanges a Firebase identity for an application account.
 *
 * Google sign in creates the identity in the browser, so the account it maps to may not exist yet.
 * The call is made on every social sign in: the server provisions the account once and returns the
 * existing one afterwards.
 */
export const openSession = async (client: AxiosInstance, referralCode?: string) =>
    responseHandler<ApiSportsEndPointResponse<User>>(client.post('/auth/session', {
        referralCode: referralCode || storedReferralCode()
    }))

export const updateProfile = async (client: AxiosInstance, name: string) =>
    responseHandler<ApiSportsEndPointResponse<User>>(client.put('/auth/profile', {name}))

export const logout = async (client: AxiosInstance) =>
    responseHandler<void>(client.get('/auth/logout'))
